import { render, staticRenderFns } from "./situacionesPersonalesShow.vue?vue&type=template&id=4fbf7aa1&scoped=true&"
import script from "./situacionesPersonalesShow.vue?vue&type=script&lang=js&"
export * from "./situacionesPersonalesShow.vue?vue&type=script&lang=js&"
import style0 from "./situacionesPersonalesShow.vue?vue&type=style&index=0&id=4fbf7aa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf7aa1",
  null
  
)

export default component.exports